module.exports = __webpack_public_path__ + "img/header.ab8c5ea.jpg";